/*!
 * Get the contrasting color for any hex color
 * (c) 2019 Chris Ferdinandi, MIT License, https://gomakethings.com
 * Derived from work by Brian Suda, https://24ways.org/2010/calculating-color-contrast/
 * @param  {String} A hexcolor value
 * @return {String} The contrasting color (black or white)
 */
var getContrast = function (hexcolor) {
  hexcolor = formatHexColor(hexcolor);

  // Convert to RGB value
  var r = parseInt(hexcolor.substr(0, 2), 16);
  var g = parseInt(hexcolor.substr(2, 2), 16);
  var b = parseInt(hexcolor.substr(4, 2), 16);

  // Get YIQ ratio
  var yiq = (r * 299 + g * 587 + b * 114) / 1000;

  // Check contrast
  return yiq >= 128 ? 'black' : 'white';
};

var formatHexColor = (hexcolor) => {
  // If a leading # is provided, remove it
  if (hexcolor.slice(0, 1) === '#') {
    hexcolor = hexcolor.slice(1);
  }

  // If a three-character hexcode, make six-character
  if (hexcolor.length === 3) {
    hexcolor = hexcolor
      .split('')
      .map(function (hex) {
        return hex + hex;
      })
      .join('');
  }

  return hexcolor;
};

var getBgClassesFromContrast = function (contrast) {
  if (contrast === 'black') {
    return 'bg-black bg-opacity-10';
  }

  return 'bg-white bg-opacity-10';
};

var getHoverBgClassesFromContrast = function (contrast) {
  if (contrast === 'black') {
    return 'hover:bg-black hover:bg-opacity-10';
  }

  return 'hover:bg-white hover:bg-opacity-10';
};

export { formatHexColor, getContrast, getBgClassesFromContrast, getHoverBgClassesFromContrast };
